import {
  LOCAL_ACTIVE_ROL,
  LOCAL_LAST_NAME,
  LOCAL_USER_EMAIL,
  LOCAL_USER_NAME,
} from "../storage"
import { MESSAGE_PAGE_SEGMENT } from "./events"

/* name pages */
export const PAGE_ORGANIZATION_DIVISION = "Organización - Divisiones"
export const PAGE_ORGANIZATION_COLLABORATOR = "Organizacion - Colaboradores"
export const PAGE_MODEL_SURVEY = "Cuestionario"
export const PAGE_MODEL_MEASUREMENT = "Historial de Mediciones"
export const PAGE_REPORT = "Reportes"

import moment from "moment-timezone"

/* Date using Moment */
export const TIME_ZONE = "America/Lima"
export const FORMAT_DATE = "YYYY-MM-DD h:mm:ss a"

export const identifyUserSegment = () => {
  const today = moment()
    .tz(TIME_ZONE)
    .format(FORMAT_DATE)
  const someData = {
    nombre: LOCAL_USER_NAME(),
    apellido: LOCAL_LAST_NAME(),
    tipo_usuario: LOCAL_ACTIVE_ROL(),
    fecha: today || new Date(),
  }
  return someData
}
/**
 *
 * @param page
 */
export const visitPageSegment = (page) => {
  window.analytics.track(MESSAGE_PAGE_SEGMENT, {
    data: identifyUserSegment(),
    pagina_visitada: page,
    email: LOCAL_USER_EMAIL(),
  })
}
